import { render } from "./LoginAndSignUp.vue?vue&type=template&id=291047bf"
import script from "./LoginAndSignUp.vue?vue&type=script&lang=js"
export * from "./LoginAndSignUp.vue?vue&type=script&lang=js"

import "./LoginAndSignUp.vue?vue&type=style&index=0&id=291047bf&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__